export type RouteConfig = {
  path: string;
  name: string;
  component: () => Promise<any>;
  meta?: Record<string, any>;
};

export function routeMapper(routeMap: RouteConfig[]) {
  return Object.entries(routeMap).map(
    ([defaultPath, { path = defaultPath, ...config }]) => ({ path, ...config }),
  );
}
